import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const FormWrapper = styled.div`
  font-size: 12px;
  background-color: #fff;
  margin-top: 25px;

  .error-msg {
    color: red;
    margin-left: 10px;
  }
`;

export const FormText = styled.p`
  margin-top: 20px;
  color: #6c7488;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
`;

export const FormItem = styled.div`
  padding-bottom: 22px;
  font-weight: 300;
  color: #6c7488;
  position: relative;

  .error-msg {
    margin-left: 5px;
    color: red;
    font-size: 12px;
  }
  .fileUpload {
    display: none;
  }
  .uploadButton {
    display: block;
    margin-top: 30px;
    cursor: pointer;
    font-size: large;
  }
  .pending {
    font-style: italic;
  }
`;

export const FormCheckbox = styled.input`
  display: inline-block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-left: 20px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}

export const VInput = styled(Input)<VInputProps>`
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  margin-bottom: 5px;
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const AddNewUser = styled.button`
  color: blue;
  cursor: pointer;
  background: none;
  border: none;
  margin-right: 40px;
`;
